import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer, Provider } from '@angular/core';

import { BAAS_TYPES, baasContext, BaasI18n, BaasLogOffHook } from '@lvflanders/bar';
import { provideBaasInitialized } from '@lvflanders/bar-ng';

import { ApiModule } from './api/api.module';
import { StartschermLogOffHook } from './hooks/startscherm-log-off-hook';
import { StartschermCoreOptions } from './models/startscherm-core-options.model';
import { StartschermV2FormatteerInternalService } from './services/v2/startscherm-v2-formatteer-internal.service';
import { StartschermV2KlantService } from './services/v2/startscherm-v2-klant.service';
import { StartschermV2StartupService } from './services/v2/startscherm-v2-startup.service';
import { StartschermV2StateService } from './services/v2/startscherm-v2-state.service';
import { STARTSCHERM_I18N } from './startscherm.i18n';

export function provideStartscherm(options?: StartschermCoreOptions) {
    // NOTE inject log off hook in non-angular section
    if (baasContext?.container) {
        baasContext.container.bind<BaasLogOffHook>(BAAS_TYPES.BaasLogOffHook).to(StartschermLogOffHook);
    } else console.warn('No container found in the BaaS context or BaaS context not defined.');

    const providers: (Provider | EnvironmentProviders)[] = [
        StartschermV2StateService,
        StartschermV2KlantService,
        StartschermV2FormatteerInternalService,
        ApiModule.forRoot({}).providers,
        provideBaasInitialized(StartschermV2StartupService),
        provideEnvironmentInitializer(() => inject(BaasI18n).addTranslations('DOMAIN_STARTSCHERM', STARTSCHERM_I18N)),
        {
            provide: StartschermCoreOptions,
            useValue: options
        }
    ];
    return makeEnvironmentProviders(providers);
}
